export default {
  'get-list': {
    method: 'post',
    url: 'partner/trip/journey/list'
  },
  responseAllocation: {
    method: 'post',
    url: 'partner/trip/journey/allocation/response'
  }
}
